/**
 * Seeded RNG (mulberry32) so combat and loot are reproducible and testable.
 * Keep the seed in the save to make sessions deterministic when desired.
 */

export class Rng {
  /**
   * @param {number} [seed] initial 32-bit seed; random if omitted
   */
  constructor(seed) {
    this.state = (seed ?? (Math.random() * 2 ** 32)) >>> 0;
  }

  /**
   * Next float in [0, 1).
   * @returns {number}
   */
  next() {
    let t = (this.state += 0x6d2b79f5);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }

  /**
   * Float in [min, max).
   * @param {number} min
   * @param {number} max
   * @returns {number}
   */
  range(min, max) {
    return min + this.next() * (max - min);
  }

  /**
   * Integer in [min, max] inclusive.
   * @param {number} min
   * @param {number} max
   * @returns {number}
   */
  int(min, max) {
    return Math.floor(this.range(min, max + 1));
  }

  /**
   * Roll a probability in [0,1]; true on success.
   * @param {number} chance
   * @returns {boolean}
   */
  chance(chance) {
    return this.next() < chance;
  }

  /**
   * Pick a random element from an array.
   * @template T
   * @param {T[]} arr
   * @returns {T}
   */
  pick(arr) {
    return arr[this.int(0, arr.length - 1)];
  }
}
